import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-play-circle-fill text-white text-xl"></i>
          </div>
          <span className={`text-xl font-bold transition-colors ${scrolled ? "text-foreground-950" : "text-white"}`}>
            51动漫
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === "/"
                ? scrolled
                  ? "text-primary-500"
                  : "text-white"
                : scrolled
                  ? "text-foreground-700 hover:text-foreground-950"
                  : "text-white/80 hover:text-white"
            }`}
          >
            首页
          </Link>
          {animeCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? scrolled
                    ? "text-primary-500"
                    : "text-white"
                  : scrolled
                    ? "text-foreground-700 hover:text-foreground-950"
                    : "text-white/80 hover:text-white"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === "/about"
                ? scrolled
                  ? "text-primary-500"
                  : "text-white"
                : scrolled
                  ? "text-foreground-700 hover:text-foreground-950"
                  : "text-white/80 hover:text-white"
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer">
            <i className={`ri-search-line ${scrolled ? "text-foreground-700" : "text-white"}`}></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${scrolled ? "text-foreground-950" : "text-white"} ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors">
              首页
            </Link>
            {animeCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}